import {CREDIT_BLOCK_REASON, GSI_DAAS_TARGET_SYSTEMS, GSI_MCS_TARGET_SYSTEMS, TARGET_SYSTEM} from "../helpers/app-constants";

export interface CreditCheckReportHistory {
  id: string;
  dartDeals: string;
  soldToBpId: string;
  billToBpId: string;
  payerBpId: string;
  paymentTerms: string;
  evaluated: Date;
  customer: string;
  soldTo: string;
  creditAnalyst: string;
  tcv: number;
  currency: string;
  durationInMonth: number;
  country: string;
  status: string;
  creditBlockReason: string;
  releasedOn: Date;
  releasedByUser: string;
  businessModel: string;
  payerName: string;
  credtedByUser: string;
  blockedTime: string;
  releasedTime: string;
  opportunityDesc: string;
  tcvFormatted: string;
}

export interface CreditCheckAnalyst{
  credit_analyst: string;
}
export function CreditCheckAnalystModelFactory(json?: any): CreditCheckAnalyst {
  json = json || {};

  return {
    credit_analyst: json.credit_analyst || "",
  } as CreditCheckAnalyst;
}

const getCreditBlockReason = (ccBlockCode) => {
  if (ccBlockCode) {
    return `${ccBlockCode} - ${CREDIT_BLOCK_REASON[ccBlockCode]}`;
  } return ``;
};
const getBusinessModel = (targetSystem) => {
  if (
    targetSystem === "pmpsc" ||
    targetSystem === TARGET_SYSTEM.PMPS_SELL_WITH ||
    targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH
  ) return "pMPS (Managed Complete)";
  if (targetSystem === "pmpsp" || targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH) return "pMPS (Managed page)";

  if (GSI_DAAS_TARGET_SYSTEMS.includes(targetSystem)) return "DaaS";
  if (GSI_MCS_TARGET_SYSTEMS.includes(targetSystem)) return "MCS";
  return targetSystem;
};

const getBusinessType = (targetSystem) => {
  if (targetSystem === "daas") return "DaaS";
  if (GSI_DAAS_TARGET_SYSTEMS.includes(targetSystem)) return "GSI DaaS";
  if(GSI_MCS_TARGET_SYSTEMS.includes(targetSystem)) return "GSI MCS";
  return "MPS";
};

export function CreditCheckReportHistoryDataModelFactory(json?: any): CreditCheckReportHistory {
  json = json || {};
  return {
    id: json.id || "",
    dartDeals: json.dartDeals || "",
    soldToBpId: json.soldToBpId || "-",
    billToBpId: json.billToBpId || "-",
    payerBpId: json.payerBpId || "-",
    paymentTerms: json.paymentTerms || "",
    evaluated: json.evaluated || "",
    customer: json.customer || "",
    soldTo: json.soldTo || "",
    creditAnalyst: json.creditAnalyst || "",
    tcv: json.tcv || "",
    currency: json.currency || "",
    durationInMonth: json.durationInMonth || "",
    country: json.country || "",
    status: json.status || "",
    creditBlockReason: getCreditBlockReason(json.creditBlockReason) || "",
    releasedOn: json.releasedOn || "",
    releasedByUser: json.releasedByUser || "",
    businessModel: getBusinessModel(json.targetSystem) || "",
    businessType: getBusinessType(json.targetSystem) || "",
    payerName: json.payerName || "",
    credtedByUser: json.credtedByUser || "",
    blockedTime: json.blockedTime || "",
    releasedTime: json.releasedTime || "",
    opportunityDesc: json.opportunityDesc || "",
    tcvFormatted: (json.tcv && !Number.isNaN(json.tcv)) ? Number(json.tcv).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "",
    contractAccountId: json.contractAccountId || "",
  } as CreditCheckReportHistory;
}
